<template>
  <v-container fluid>
    <v-card>
      <v-container>
        <v-layout row wrap v-show="gettingExistingRequests">
          <v-flex xs-12 class="text-xs-center">
            <v-progress-circular class="ma-5" :size="70" :width="7" indeterminate color="primary"></v-progress-circular>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-btn color="primary" class="mb-4 v-btn--block" @click="newRequestDialog = true">New Request</v-btn>
            <v-container class="hidden-xs-only">
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <h1 class="title">Current Period</h1>
                  <h1 class="subtitle-1">{{ holAllowance.period_start | formatDate('DD/MM/YYYY') }} -
                    {{ holAllowance.period_end | formatDate('DD/MM/YYYY') }}</h1>
                  <!-- <h4 class="subtitle-2"><b>Holidays Left:</b> {{ holAllowance.total_approved_days_left }}</h4> -->
                  <h4 class="subtitle-2"><b>Remaining Holiday Allowance (including any unapproved requests):</b>
                    {{ holAllowance.total_days_left }}</h4>
                  <h4 class="mb-3 subtitle-2" v-if="holAllowance.currentLieuAllowance > 0"><b>Lieu Days Left:</b> {{
                    holAllowance.currentLieuAllowance }}</h4>
                </v-flex>
                <v-flex xs12 sm6>
                  <h1 class="title">Next Period</h1>
                  <h1 class="subtitle-1">{{ holAllowance.period_start | formatNextHolPrdDate('DD/MM/YYYY') }} -
                    {{ holAllowance.period_end | formatNextHolPrdDate('DD/MM/YYYY') }}</h1>
                  <!-- <h4 class="subtitle-2"><b>Holidays Left:</b> {{ holAllowance.total_next_period_approved_days_left }}</h4> -->
                  <h4 class="subtitle-2"><b>Remaining Holiday Allowance (including any unapproved requests):</b>
                    {{ holAllowance.total_next_period_days_left }}</h4>
                  <h4 class="mb-3 subtitle-2" v-if="holAllowance.nextLieuAllowance > 0"><b>Lieu Days Left:</b> {{
                    holAllowance.nextLieuAllowance }}</h4>
                </v-flex>
              </v-layout>
            </v-container>
            <div class="hidden-xs-only mb-4">
              <full-calendar v-show="!gettingExistingRequests" :events="filteredRequests" @eventClick="viewEventDetails"
                @changeMonth="updateCurrentMonthYear"></full-calendar>
            </div>
            <h2 v-if="!isMobile" class="mt-0">All Existing Holiday Requests</h2>
            <h1 style="margin-bottom:5px" class="title" v-if="isMobile">All Existing Holiday Requests</h1>
            <v-checkbox v-if="!isMobile" v-model="showPastRequests" label="Include Past Requests"
              hide-details></v-checkbox>
            <v-checkbox v-if="isMobile" v-model="showPastRequests" label="Include Past Requests" hide-details
              style="margin-top: 5px;"></v-checkbox>
            <v-list two-line class="hidden-xs-only">
              
            </v-list>
          </v-flex>
        </v-layout>
        <v-layout style="display: flex; flex-direction: column; margin-top:15px">
          <!-- PREVIOUS PERIOD -->
          <div v-if="showPastRequests && previousPeriodRequests.length" class="mb-5 mt-5">

            <h1 style="margin-bottom:8px" class="title">Previous Periods</h1>
            <h1 class="subtitle-1">
              Before {{ holAllowance.period_start | formatDate('DD/MM/YYYY') }}
            </h1>
            <!-- PREVIOUS PERIODS REQUESTS -->
            <v-list two-line>
              <v-list-group v-for="request in previousPeriodRequests" :key="'previous-' + request.ID"
                v-model="request.active" :class="[
                  request.whitelisted_days == 0 ? 'error'
                    : request.type !== null ? 'blue-grey lighten-4'
                      : request.actioned === 0 ? 'warning'
                        : request.actioned === 1 ? 'success'
                          : 'error',
                  'white--text',
                  'mb-1'
                ]">
                <v-list-tile slot="activator">
                  <v-list-tile-content>

                    <v-list-tile-title>
                      <strong v-if="request.type === null && request.whitelisted_days > 0" class="white--text">
                        {{ request.actioned | filterActionText }}:
                      </strong>

                      <strong v-if="request.type_name !== null && request.whitelisted_days > 0">
                        {{ request.type_name }}
                        <span v-if="request.actioned === 5" class="has-text-danger"> - DELETED</span>
                      </strong>

                      <strong v-if="request.whitelisted_days == 0" class="white--text">
                        Cancelled
                      </strong>
                    </v-list-tile-title>

                    <v-list-tile-sub-title>
                      {{ request.start | formatDate('DD/MM/YYYY') }}
                      <span v-if="request.end"> - {{ request.end | formatDate('DD/MM/YYYY') }}</span>
                    </v-list-tile-sub-title>

                    <v-list-tile-sub-title v-if="company !== 'lfp'">
                      {{ request | formatTime }}
                    </v-list-tile-sub-title>

                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-btn v-if="(request.actioned == 0 || request.actioned == 1) && request.whitelisted_days > 0" icon
                      flat @click="selectedRequestObj = request; editRequestDialog = true">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>

                <v-container fluid>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div class="white--text" style="margin-bottom:25px" v-for="(audit, i) in request.auditlog"
                        :key="request.ID + '-audit-' + i">
                        {{ audit.date | formatDate('DD/MM/YYYY HH:mm') }} : {{ audit.content }}
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-list-group>
            </v-list>
          </div>
          <!-- CURRENT PERIOD INFO -->
          <div class="mb-3 mt-5">
            <h1 style="margin-bottom:8px" class="title">Current Period</h1>
            <h1 class="subtitle-1">
              {{ holAllowance.period_start | formatDate('DD/MM/YYYY') }} -
              {{ holAllowance.period_end | formatDate('DD/MM/YYYY') }}
            </h1>
            <h4 class="subtitle-2" v-if="isMobile">
              <b>Remaining Holiday Allowance:</b> {{ holAllowance.total_days_left }}
            </h4>
          </div>

          <!-- CURRENT PERIOD REQUESTS -->
          <v-list two-line>
            <v-list-group v-for="request in currentPeriodRequests" :key="'current-' + request.ID"
              v-model="request.active" :class="[
                request.whitelisted_days == 0 ? 'error'
                  : request.type !== null ? 'blue-grey lighten-4'
                    : request.actioned === 0 ? 'warning'
                      : request.actioned === 1 ? 'success'
                        : 'error',
                'white--text',
                'mb-1'
              ]">
              <v-list-tile slot="activator">
                <v-list-tile-content>

                  <v-list-tile-title>
                    <strong v-if="request.type === null && request.whitelisted_days > 0" class="white--text">
                      {{ request.actioned | filterActionText }}:
                    </strong>

                    <strong v-if="request.type_name !== null && request.whitelisted_days > 0">
                      {{ request.type_name }}
                      <span v-if="request.actioned === 5" class="has-text-danger"> - DELETED</span>
                    </strong>

                    <strong v-if="request.whitelisted_days == 0" class="white--text">
                      Cancelled
                    </strong>
                  </v-list-tile-title>

                  <v-list-tile-sub-title>
                    {{ request.start | formatDate('DD/MM/YYYY') }}
                    <span v-if="request.end"> - {{ request.end | formatDate('DD/MM/YYYY') }}</span>
                  </v-list-tile-sub-title>

                  <v-list-tile-sub-title v-if="company !== 'lfp'">
                    {{ request | formatTime }}
                  </v-list-tile-sub-title>

                </v-list-tile-content>

                <v-list-tile-action>
                  <v-btn v-if="(request.actioned == 0 || request.actioned == 1) && request.whitelisted_days > 0" icon
                    flat @click="selectedRequestObj = request; editRequestDialog = true">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>

              <v-container fluid>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div class="white--text" style="margin-bottom:25px" v-for="(audit, i) in request.auditlog"
                      :key="request.ID + '-audit-' + i">
                      {{ audit.date | formatDate('DD/MM/YYYY HH:mm') }} : {{ audit.content }}
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-list-group>
          </v-list>

          <!-- NEXT PERIOD INFO -->
          <div class="mt-5 mb-3">
            <h1 style="margin-bottom:8px" class="title">Next Period</h1>
            <h1 class="subtitle-1">
              {{ holAllowance.period_start | formatNextHolPrdDate('DD/MM/YYYY') }} -
              {{ holAllowance.period_end | formatNextHolPrdDate('DD/MM/YYYY') }}
            </h1>
            <h4 class="subtitle-2" v-if="isMobile">
              <b>Remaining Holiday Allowance:</b> {{ holAllowance.total_next_period_days_left }}
            </h4>
          </div>

          <!-- NEXT PERIOD REQUESTS -->
          <v-list two-line>
            <v-list-group v-for="request in nextPeriodRequests" :key="'next-' + request.ID" v-model="request.active"
              :class="[
                request.whitelisted_days == 0 ? 'error'
                  : request.type !== null ? 'blue-grey lighten-4'
                    : request.actioned === 0 ? 'warning'
                      : request.actioned === 1 ? 'success'
                        : 'error',
                'white--text',
                'mb-1'
              ]">
              <v-list-tile slot="activator">
                <v-list-tile-content>

                  <v-list-tile-title>
                    <strong v-if="request.type === null && request.whitelisted_days > 0" class="white--text">
                      {{ request.actioned | filterActionText }}:
                    </strong>

                    <strong v-if="request.type_name !== null && request.whitelisted_days > 0">
                      {{ request.type_name }}
                      <span v-if="request.actioned === 5" class="has-text-danger"> - DELETED</span>
                    </strong>

                    <strong v-if="request.whitelisted_days == 0" class="white--text">
                      Cancelled
                    </strong>
                  </v-list-tile-title>

                  <v-list-tile-sub-title>
                    {{ request.start | formatDate('DD/MM/YYYY') }}
                    <span v-if="request.end"> - {{ request.end | formatDate('DD/MM/YYYY') }}</span>
                  </v-list-tile-sub-title>

                  <v-list-tile-sub-title v-if="company !== 'lfp'">
                    {{ request | formatTime }}
                  </v-list-tile-sub-title>

                </v-list-tile-content>

                <v-list-tile-action>
                  <v-btn v-if="(request.actioned == 0 || request.actioned == 1) && request.whitelisted_days > 0" icon
                    flat @click="selectedRequestObj = request; editRequestDialog = true">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>

              <v-container fluid>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div class="white--text" style="margin-bottom:25px" v-for="audit in request.auditlog"
                      :key="audit.date + audit.content">
                      {{ audit.date | formatDate('DD/MM/YYYY HH:mm') }} : {{ audit.content }}
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-list-group>
          </v-list>
        </v-layout>
      </v-container>
    </v-card>
    <New-Holiday-Request-Dialog 
    :nextPeriodReleaseDays="nextPeriodReleaseDays"
    :workerType="empDetails.worker_type" 
    :showDialog="newRequestDialog"
    :holAllowance="holAllowance" 
    @closeNewRequestDialog="newRequestDialog = false"
    @requestSubmitted="getExistingRequests" class="mb-4">
    </New-Holiday-Request-Dialog>
    <Edit-Holiday-Request-Dialog 
    :showDialog="editRequestDialog" 
    :requestObj="selectedRequestObj"
    @closeEditRequestDialog="editRequestDialog = false" 
    @requestSubmitted="getExistingRequests"
    class="mb-4">
    </Edit-Holiday-Request-Dialog>
  </v-container>
</template>
<script>
import fullCalendar from 'vue-fullcalendar'
import axios from 'axios'
import moment from 'moment'
export default {
  props: ['showDialog', 'workerType'],
  components: {fullCalendar},
  data () {
    return {
      url: this.$store.getters.url,
      user: this.$store.getters.user,
      company: this.$store.getters.company,
      newRequestDialog: false,
      editRequestDialog: false,
      requests: [],
      gettingExistingRequests: false,
      currentMonthYear: moment().format('YYYY-MM'),
      showPastRequests: false,
      selectedRequestObj: {},
      empDetails: {},
      holAllowance: {},
      currentLieuAllowance: 0,
      nextLieuAllowance: 0,
      nextPeriodReleaseDays: '-1'
    }
  },
  mounted () {
    this.getExistingRequests()
    this.getEmpDetails()
    this.getNextPeriodReleaseDays()
  },
  filters: {
    formatDate (date, format) {
      return moment(date).format(format)
    },
    formatNextHolPrdDate (date, format) {
      return moment(date).add(1, 'year').format(format)
    },
    filterActionText (val) {
      if (val === 0) {
        return 'Pending'
      } else if (val === 1) {
        return 'Approved'
      } else if (val === 2) {
        return 'Declined'
      } else if (val === 3) {
        return 'Cancellation Requested'
      } else if (val === 5) {
        return 'Holiday Deleted'
      }
    },
    formatTime (val) {
      let startTimestamp = moment('1970-01-01 ' + ((val.hour * 1) < 10 ? '0' + val.hour : val.hour) + ':00').add(val.minute, 'minutes').format('h:mma')
      let endTime = (val.hour + val.length) > 24 ? (val.hour + val.length) - 24 : (val.hour + val.length)
      let endTimestamp = moment('1970-01-01 ' + (endTime) + ':00').add(val.minute, 'minutes').format('h:mma')
      return startTimestamp + ' - ' + endTimestamp
    }
  },
  computed: {
    filteredRequests () {
      let filteredRequests = []
      const currentMonthYear = this.currentMonthYear
      this.requests.forEach(request => {
        switch (request.actioned) {
          case 0:
            request.cssClass = 'pending'
            request.title = 'Pending'
            break
          case 1:
            request.cssClass = 'approved'
            request.title = 'Approved'
            break
          case 2:
            request.cssClass = 'rejected'
            request.title = 'Rejected'
            break
          case 3:
            request.cssClass = 'cancellation'
            request.title = 'Cancellation Requested'
            break
          case 5:
            request.cssClass = 'rejected'
            request.title = 'Holiday Deleted'
            break
        }
        if (request.whitelisted_days === 0) {
          request.cssClass = 'rejected'
          request.title = 'Holiday Cancelled'
        }
        let startTimestamp = moment('1970-01-01 ' + request.hour + ':00').add(request.minute, 'minutes').format('h:mma')
        let endTime = (request.hour + request.length) > 24 ? (request.hour + request.length) - 24 : (request.hour + request.length)
        let endTimestamp = moment('1970-01-01 ' + (endTime) + ':00').add(request.minute, 'minutes').format('h:mma')
        if (this.company !== 'lfp') {
          request.title = request.title + ' ' + startTimestamp + ' - ' + endTimestamp
        }
        const requestMonthYear = moment(request.start, 'YYYY-MM-DD').format('YYYY-MM')
        if (requestMonthYear === currentMonthYear) {
          filteredRequests.push(request)
        }
      })
      return filteredRequests
    },
    isMobile () {
      return this.$vuetify.breakpoint.xs
    },
    currentPeriodEnd () {
      return moment(this.holAllowance.period_end, 'YYYY-MM-DD')
    },
    currentPeriodStart () {
      return moment(this.holAllowance.period_start, 'YYYY-MM-DD')
    },
    previousPeriodRequests () {
      return this.requestsToDisplay
        .filter(r => moment(r.start).isBefore(this.currentPeriodStart))
        .sort((a, b) => moment(b.start).diff(moment(a.start)))
    },
    currentPeriodRequests () {
      return this.requestsToDisplay
        .filter(r =>
          moment(r.start).isSameOrAfter(this.currentPeriodStart) &&
          moment(r.start).isSameOrBefore(this.currentPeriodEnd))
        .sort((a, b) => moment(b.start).diff(moment(a.start)))
    },
    nextPeriodRequests () {
      return this.requestsToDisplay
        .filter(r => moment(r.start).isAfter(this.currentPeriodEnd))
        .sort((a, b) => moment(b.start).diff(moment(a.start)))
    },
    requestsToDisplay () {
      return this.requests.filter(r => !this.isPastDate(r.start) || this.showPastRequests)
    }
  },
  methods: {
    getExistingRequests () {
      this.gettingExistingRequests = true
      axios.post(this.url + `/tanda-service/getEmpHolRequests.ajax.php`, {empID: this.user.empID, company: this.company})
        .then(result => {
          if (result.data) {
            this.requests = result.data.requests
            this.holAllowance = result.data.total_days
            this.holAllowance.total_next_period_approved_days_left = this.calculatedAllowanceNextPeriod(this.holAllowance.hol_count, this.holAllowance.nextHolidayOverride, this.holAllowance.nextHolidayCarryover, this.holAllowance.next_bonus_to_be_awarded)
            this.currentLieuAllowance = result.data.total_days.currentLieuAllowance
            this.nextLieuAllowance = result.data.total_days.nextLieuAllowance
            this.orderAuditLog(result.data.audit)
            this.gettingExistingRequests = false
          } else {
            this.gettingExistingRequests = false
          }
        })
    },
    // calculate the Calcualted Allowance
    calculatedAllowanceNextPeriod (basicAllowance, overrideValue, carryOverValue, bonusValue) {
      // calculated allowance will be basic allowance if no other factors apply
      let totalAllowance = basicAllowance
      // if carryover value exists, and is from the previous year to current year
      if (carryOverValue) {
        totalAllowance = totalAllowance + carryOverValue
      }

      // add any bonus values to allowance for years served
      if (bonusValue) {
        totalAllowance = totalAllowance + bonusValue
      }

      if (overrideValue) {
        totalAllowance = overrideValue
      }

      return totalAllowance
    },
    orderAuditLog (auditLog) {
      for (let request in this.requests) {
        let currentRequest = this.requests[request]
        let currentRequestAuditLogs = auditLog.filter(a => a.holID === currentRequest.ID)
        for (let currentAuditLog in currentRequestAuditLogs) {
          let currentLog = currentRequestAuditLogs[currentAuditLog]
          const comment = currentLog.comment ? currentLog.comment.toString() : ''
          if (currentLog.original_count === 0 && currentLog.new_count === 0 && comment !== 'Unarchived') {
            currentRequest.auditlog.push({
              'date': currentLog.modified_date,
              'content': 'Cancel Request Rejected By ' + currentLog.modified_by + ' - ' + (comment.length === 0 ? '(No Comment Provided)' : comment)
            })
          } else if (comment !== 'Unarchived') {
            currentRequest.auditlog.push({
              'date': currentLog.modified_date,
              'content': 'Request Modified By ' + currentLog.modified_by + ' - Request has been modified from ' + currentLog.original_count + ' day(s) to ' + currentLog.new_count + ' day(s) - ' + (comment.length === 0 ? '(No Comment Provided)' : comment)
            })
          } else {
            currentRequest.auditlog.push({
              'date': currentLog.modified_date,
              'content': 'Request Modified By ' + currentLog.modified_by + ' - Request has been modified from ' + currentLog.original_count + ' day(s) to ' + currentLog.new_count + ' day(s) - ' + (comment.length === 0 ? '(No Comment Provided)' : comment)
            })
          }
        }

        if (currentRequest.type == null) {
          currentRequest.auditlog.push({
            'date': currentRequest.date_requsted,
            'content': 'Request Submitted'
          })
          let action = ''
          switch (currentRequest.actioned) {
            case 1:
              action = 'Request Actioned By '
              break
            case 2:
              action = 'Request Rejected By '
              break
            case 3:
              action = 'Cancellation Requested '
              break
            case 5:
              action = 'Holiday Deleted By '
              break
          }
          if (currentRequest.actioned > 0 && currentRequest.actioned < 6) {
            const comment = currentRequest.comment ? currentRequest.comment.toString() : ''
            currentRequest.auditlog.push({
              'date': currentRequest.date_authorized,
              'content': action + currentRequest.authorized_by + ' - ' + (comment.length === 0 ? '(No Comment Provided)' : comment)
            })
          }
        } else {
          const comment = currentRequest.comment ? currentRequest.comment.toString() : ''
          currentRequest.auditlog.push({
            'date': currentRequest.date_requsted,
            'content': 'Request Created By ' + currentRequest.authorized_by + ' - ' + (comment.length === 0 ? '(No Comment Provided)' : comment)
          })
        }
        currentRequest.auditlog = currentRequest.auditlog.sort((a, b) => moment(b.date).diff(moment(a.date), 'minutes'))
      }
    },

    viewEventDetails (event, jsEvent, pos) {
      if (event.whitelisted_days > 0) {
        this.selectedRequestObj = event
        this.editRequestDialog = true
      }
    },
    updateCurrentMonthYear (start, end, current) {
      this.currentMonthYear = moment(current).format('YYYY-MM')
    },
    isPastDate (date) {
      return moment(date).isBefore(moment().startOf('day'))
    },
    getEmpDetails () {
      axios.post(this.url + `/tanda-service/getEmpDetails.ajax.php`, {
        company: this.company,
        empID: this.user.empID
      })
        .then(response => {
          this.empDetails = response.data
        })
        .catch(e => {
          console.log(e)
        })
    },
    getNextPeriodReleaseDays () {
      axios.post(this.url + `/tanda-service/getNextPeriodReleaseDays.ajax.php`, {
        company: this.company
      })
        .then(response => {
          this.nextPeriodReleaseDays = response.data[0].value
        })
        .catch(e => {
          console.log(e)
        })
    }
  }
}
</script>
<style>
.comp-full-calendar {
  padding:0!important;
}
.event-item.pending {
  background-color: #FFC107!important;
  color: #fff!important;
}
.event-item.approved {
  background-color: #4CAF50!important;
  color: #fff!important;
}
.event-item.cancellation {
  background-color: #1F8FEA!important;
  color: #fff!important;
}
.event-item.rejected {
  background-color: #FF5252!important;
  color: #fff!important;
}
</style>


// WEBPACK FOOTER //
// src/components/HolidayRequest.vue